import React, { useMemo, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { Checkbox } from "@material-ui/core";
import { StyledFormControlLabel } from "../../pages/auth/Components/Input";
import checkedIcon from "../../assets/icons/icon-checked.svg";
import notCheckedIcon from "../../assets/icons/icon-not-checked.svg";
import AdminPermissionEnum, {
  AdminPermissionLabels
} from "../../enums/AdminPermissionEnum";
import styles from "./styles.module.scss";

// Lista de permissoes de admin em um bloco colapsavel.
// O estado (array de permissoes) e controlado pelo form pai.
const PermissionsSelector = ({ permissions = [], onToggle }) => {
  const [expanded, setExpanded] = useState(false);

  const options = useMemo(
    () =>
      Object.values(AdminPermissionEnum).map(value => ({
        value,
        label: AdminPermissionLabels[value]
      })),
    []
  );

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={styles.header}
        onClick={() => setExpanded(prev => !prev)}
      >
        <span>Permissões do admin ({permissions.length})</span>
        <FiChevronDown
          className={`${styles.chevron} ${expanded ? styles.chevronOpen : ""}`}
        />
      </button>

      {expanded && (
        <div className={styles.list}>
          {options.map(opt => (
            <div key={opt.value} className={styles.item}>
              <StyledFormControlLabel
                control={
                  <Checkbox
                    name={opt.value}
                    checked={permissions.includes(opt.value)}
                    onChange={() => onToggle(opt.value)}
                    icon={<img src={notCheckedIcon} alt="" />}
                    checkedIcon={<img src={checkedIcon} alt="" />}
                    label=""
                  />
                }
                label={opt.label}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PermissionsSelector;
